<template>
  <div class="party-home">
    <div class="top">
      <img src="@/assets/partyhome/dp-dy-sy1.png" alt />
      <div class="top-msg">
        <div class="top-left">
          <p>
            <span>您好！</span>
            <span>{{bodyMsg.name}}</span>
          </p>
          <p>欢迎来到{{bodyMsg.adress}}</p>
        </div>
        <div class="top-right">
          <img :src="bodyMsg.headImg | filterB" alt />
        </div>
      </div>
      <div class="icon-list">
        <div class="list-box">
          <div
            class="list-template"
            v-for="list in lists"
            :key="list.name"
            @click="goIcon(list.name)"
          >
            <div class="left-list">
              <img :src="list.imgUrl" alt />
            </div>
            <div class="right-list">
              <p v-text="list.name"></p>
              <p v-text="list.workContent"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 三会一课 -->
    <div class="three-meeting">
      <div class="title">三会一课</div>
      <div class="three-list">
        <div
          class="three-list-template"
          v-for="(threeList,index) in threeLists"
          :key="threeList.imgUrl"
          @click="goThreeMeeting(index)"
          v-show="threeList.shows"
        >
          <img :src="threeList.imgUrl" />
        </div>
        
      </div>
    </div>

    <!-- 远程教育 -->
    <div class="remoteEdu">
      <div class="title">
        <p>远程教育- 教学动态</p>
        <p @click="goList">查看全部</p>
      </div>
      <div
        class="news-template"
        v-for="news in sevenLine"
        :key="news.id"
        @click="goDetail(news.id)"
      >
        <div class="news-left">
          <img :src="news.imgurl" alt v-if="news.imgurl==null?false:true" />
        </div>
        <div class="news-right">
          <p>{{news.headline}}</p>
          <p>
            <!-- <span style="margin-right:.5rem;">浏览:{{news.sees}}</span>
            <span>点赞:{{news.praise}}</span>-->
            <span style="margin-right:.3rem;float:right">{{news.createtime|times}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  // 所有接口都调用的 index 的接口,后续需要更改
  data() {
    return {
      bodyMsg: {
        name: sessionStorage.getItem("name"),
        adress: sessionStorage.getItem("partybrach"),
        headImg:
          sessionStorage.getItem("imgheader") == ""
            ? require("@/assets/partyhome/dp-dy-sy1.png")
            : sessionStorage.getItem("imgheader")
      },
      lists: [
        {
          imgUrl: require("@/assets/partyhome/dp-dy-sy3.png"),
          name: "职责分工",
          workContent: "干部信息公开"
        },
        {
          imgUrl: require("@/assets/partyhome/dp-dy-sy4.png"),
          name: "后备干部",
          workContent: "后备干部信息公开"
        },
        {
          imgUrl: require("@/assets/partyhome/dp-dy-sy5.png"),
          name: "党员管理",
          workContent: "组织关系 缴纳党费"
        },
        {
          imgUrl: require("@/assets/partyhome/dp-dy-sy6.png"),
          name: "党务公开",
          workContent: "党务村务财务公开"
        }
      ],
      threeLists: [
        { imgUrl: require("@/assets/partyhome/dp-dy-sy7.0.png") ,shows:true},
        { imgUrl: require("@/assets/partyhome/dp-dy-sy8.0.png") ,shows:true},
        { imgUrl: require("@/assets/partyhome/dp-dy-sy9.0.png"),shows:sessionStorage.getItem("roleid") == 0 ? false :true }
      ],
      sevenLine: [],
    };
  },
  mounted: function() {
    this.getList();
  },
  filters: {
    filterB: function(value) {      
      if (value)
        return value.indexOf("base64,") > -1
          ? value
          : `http://dp.djplus.cn/UserImg/${value}`;
    }
  },
  methods: {
    goDetail(newsid) {
      this.$router.push({
        path: "publicDetail",
        query: { title: "远程教育", id: newsid, dbnum: 2 }
      });
    },
    goList() {
      this.$router.push({
        path: "partyhome/remoteedu",
        query: { url: "/GetPublicList", title: "远程教育" }
      });
    },
    goIcon(value) {
      switch (value) {
        case "职责分工":
          this.$router.push({
            path: "partyhome/workduty",
            query: { title: value }
          });
          break;
        case "后备干部":
          this.$router.push({
            path: "partyhome/workduty",
            query: { title: value }
          });
          break;
        case "党员管理":
          this.$router.push({
            path: "partyhome/partymanage",
            query: { title: value }
          });
          break;
        case "党务公开":
          this.$router.push({
            path: "partyhome/partyaffairs",
            query: { title: value }
          });
          break;
      }
    },
    goThreeMeeting(index) {
      switch (index) {
        case 2:
          if (sessionStorage.getItem("roleid") == 0) alert("您没有权限");
          else {
            this.$router.push("partyhome/threemeeting");
          }
          break;
        case 1:
          this.$router.push({
            path: "/partyhome/internetclass",
            query: { title: "网上三会一课" }
          });
          break;
          case 0 :
          this.$router.push({
            path: "/partyhome/threemeeting/activeconsult",
            query: { title: "三会一课资讯" }
          });
        default:
          break;
      }
    },
    getList() {
      this.axios
        .post("/api/Party/Dynamic", { post: sessionStorage.getItem("token") })
        .then(e => {
          if (e.data.code == 0) {
            this.sevenLine = e.data.msg;
          }
        });
    }
  }
};
</script>


<style lang="scss" scoped>
.party-home {
  .remoteEdu {
    .title {
      p {
        &:nth-child(1) {
          font-weight: bold;
        }
      }
      display: flex;
      background: #fff;
      padding: 0 0.2rem;
      line-height: 3;
      justify-content: space-between;
    }
    .news-template {
      width: 94%;
      margin: 0 auto;
      display: flex;
      margin-bottom: 0.2rem;
      background: #fff;
      padding: 0.2rem 0;
      margin-top: 0.3rem;
      //   align-items: center;
      .news-right {
        width: 100%;
        margin-left: 0.2rem;
        p:nth-child(1) {
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          margin-bottom: 0.3rem;
          line-height: 1.8;
        }
        p:nth-child(2) {
          border-top: 0.01rem solid #e6e6e6;
          padding-top: 0.2rem;
          color: #999999;
          font-size: 0.26rem;
        }
      }
      .news-left {
        img {
          width: 2.4rem;
          height: 2rem;
        }
      }
    }
    margin-top: 0.3rem;
    // background: #fff;
  }
  .three-meeting {
    .three-list {
      .three-list-template {
        img {
          width: 100%;
          height: 100%;
        }
      }
      display: grid;
      grid-gap: .2rem;
      grid-template-columns: repeat(auto-fit,minmax(30%,1fr));
      grid-template-rows: 1fr;
      width: 94%;
      margin: 0 auto;
    }
    .title {
      font-weight: bold;
      line-height: 3;
      padding: 0 0.2rem;
    }
    background: #fff;
    margin-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
  .top {
    .icon-list {
      .list-box {
        .list-template {
          &:nth-child(1) {
            .right-list {
              p {
                &:nth-child(2) {
                  border-right: solid 0.01rem #e6e6e6;
                }
              }
              width: 100%;
            }
          }
          &:nth-child(3) {
            .right-list {
              p {
                &:nth-child(1) {
                  border-right: solid 0.01rem #e6e6e6;
                }
              }
              width: 100%;
            }
          }
          .right-list {
            p {
              &:nth-child(1) {
                font-weight: bold;
                line-height: 2;
              }
              &:nth-child(2) {
                color: #999999;
                font-size: 0.24rem;
                padding-bottom: 0.2rem;
              }
            }
          }
          .left-list {
            img {
              width: 0.68rem;
              height: 0.6rem;
              margin: 0 0.2rem;
              vertical-align: bottom;
            }
            text-align: center;
          }
          width: 49%;
          display: flex;
          align-items: center;
        }

        width: 90%;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
      }
      line-height: 2;
      background: #fff;
      padding: 0.3rem 0;
      box-shadow: 0px 0.4rem 0.6rem 0px rgba(0, 0, 0, 0.06);
    }
    .top-msg {
      .top-left {
        p {
          &:nth-child(1) {
            span {
              &:nth-child(1) {
                font-size: 0.36rem;
                font-weight: bold;
              }
            }

            line-height: 2;
          }
          &:nth-child(2) {
            &::before {
              content: "";
              position: absolute;
              width: 20%;
              height: 0.15rem;
              border-radius: 0.1rem;
              left: 0;
              bottom: -0.3rem;
              background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
                linear-gradient(#f29505, #f29505);
            }
            position: relative;
          }
          line-height: 2;
          margin-left: 0.3rem;
        }
        width: 70%;
      }
      .top-right {
        img {
          width: 0.94rem;
          height: 0.94rem;
          border-radius: 50%;
        }
        text-align: center;

        width: 30%;
      }
      position: absolute;
      width: 100%;
      display: flex;
      align-items: center;
      top: 0.3rem;
    }
    img {
      width: 100%;
    }
    position: relative;
    line-height: 0;
  }
  font-size: 0.3rem;
  padding-bottom: 1rem;
}
</style>